<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path fill="#000" d="M0 18a1 1 0 011-1h19a1 1 0 110 2H1a1 1 0 01-1-1z"/>
  <rect width="16" height="2" y="11" fill="#000" rx="1"/>
  <path fill="#000" d="M0 6a1 1 0 011-1h22a1 1 0 110 2H1a1 1 0 01-1-1z"/>
</svg>
